import styled from "styled-components";

export const TOOrderDetailsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 0.75fr 1fr;
  gap: 1em;
  margin-bottom: 2em;

  .orderIdWrapper {
    grid-column: 1/3;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1em;

    p {
      font-size: x-large;
    }

    span.danger {
      color: var(--red);
    }
    span.cool {
      color: var(--active);
    }
    span.success {
      color: var(--green);
    }

    .boxSection {
      background: #f2c94c;
      color: var(--dark);
      padding: 0.2em 1em;
      border-radius: 500px;
      font-weight: 600;
      float: right;
      cursor: pointer;
    }
  }

  label {
    font-size: medium;
    color: var(--dark-light);
    font-weight: 400;
    margin: 0;
  }

  p {
    font-weight: 600;
    font-size: medium;
    color: var(--dark);
    margin: 0;
  }
`;
